import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import api from '../../services/api';
import '../Login/styles.css';
import { toast } from 'react-toastify';
import { atualizarLogomarcaEvento } from '../../util/util';
import { getText, saveIdioma } from '../../util/translations';
import Processando from '../../components/Processando';
import { saveParticipantAuth } from '../../util/authSession';

export default function LoginRapido() {
  const { id, rota } = useParams();
  const history = useHistory();

  useEffect(() => {
    async function buscar() {
      try {
        atualizarLogomarcaEvento();
        const respostaDadosParticipante = await api({
          method: "get",
          action: `/dadosParticipante/${id}`,
        });
        const dadosParticipante = respostaDadosParticipante.data.data;
        atualizarLogomarcaEvento(dadosParticipante.evento);
        // sem isso, quem entra direto pelo link rápido navega o fluxo sem traducao_ui
        // no sessionStorage e o getText das telas seguintes renderiza vazio
        if (dadosParticipante.idioma) {
          saveIdioma(dadosParticipante.idioma);
        }

        const respostaLogin = await api({
          method: 'post',
          action: `/loginRapido/${id}`,
        });
        const dadosLogin = respostaLogin.data;

        saveParticipantAuth(dadosLogin);

        history.push(`/${rota}`);
      } catch (error) {
        toast.error(getText('error') + getText('errorRefreshPage'));
      }
    }

    buscar();
  }, [id, rota, history]);

  // Só realiza o login e redireciona; antes do idioma carregar mostra o loading bilíngue
  return <Processando idioma="both" />;
}
